import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider, createTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from '@/hooks/useAuth';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
// SC-121: self-host Poppins instead of fetching from fonts.googleapis.com.
// Removes the only third-party CSS link in the app and lets us drop the
// matching CSP entry / SRI exception. Weights match the previous Google
// Fonts request (400 / 500 / 600 / 700).
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import './styles/global.css';

const theme = createTheme({
  fontFamily: 'Poppins, sans-serif',
  primaryColor: 'violet',
  colors: {
    violet: [
      '#f1edfb',
      '#e0d5f5',
      '#d1c0ef',
      '#c1abe8',
      '#b196e2',
      '#a181dc',
      '#916cd6',
      '#784dd6',
      '#6a3ec0',
      '#5c2faa',
    ],
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MantineProvider theme={theme}>
      <Notifications position='top-right' />
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </MantineProvider>
  </StrictMode>,
);
